import css from '../tpl-css/style-section-grid-item-kynorelle-03.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#000000"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;"
>
  <div data-attribute="container" class="">
    <div class="wrap-card">
      <div data-show="true" data-attribute="title-card" class="title-card">
        <h2><span style="color:hsl(209,100%,20%);">MADE FOR REAL COMFORT, EVERY DAY</span></h2>
        <p>
          <span style="color:hsl(0,0%,25%);"
            >Designed for women who want comfort that actually lasts all day.Soft fabric, clean fit,&nbsp;</span
          ><br /><span style="color:hsl(0,0%,25%);">and a feel you don’t have to think about.</span>
        </p>
      </div>
      <div data-col-perview="4" data-attribute="list-item" class="wrap-products" style="--col-perview: 4;">
        <!-- TODO: add list item -->
        <div data-attribute="item" class="item-product">
          <div class="wrap-img">
            <img
              data-attribute="image-item-product"
              class="image-item-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ea6c72b6d4af4e944f3a.png"
              alt=""
            />
          </div>
          <div
            data-background="#FFFFFFa1"
            data-attribute="label-product"
            data-text-color="#000000"
            class="label-product"
            style="background-color: #FFFFFFa1; --background-label-product: #FFFFFFa1; color: #000000;"
          >
            SMOOTH SEAM DESIGN
          </div>
        </div>

        <div data-attribute="item" class="item-product">
          <div class="wrap-img">
            <img
              data-attribute="image-item-product"
              class="image-item-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ea70193f9a1e52b78aef.png"
              alt=""
            />
          </div>
          <div
            data-background="#FFFFFFa1"
            data-attribute="label-product"
            data-text-color="#000000"
            class="label-product"
            style="background-color: #FFFFFFa1; --background-label-product: #FFFFFFa1; color: #000000;"
          >
            SOFT STRETCH FABRIC
          </div>
        </div>

        <div data-attribute="item" class="item-product">
          <div class="wrap-img">
            <img
              data-attribute="image-item-product"
              class="image-item-product"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ea74233282fbaf983914.png"
              alt=""
            />
          </div>
          <div
            data-background="#FFFFFFa1"
            data-attribute="label-product"
            data-text-color="#000000"
            class="label-product"
            style="background-color: #FFFFFFa1; --background-label-product: #FFFFFFa1; color: #000000;"
          >
            ALL DAY COMFORT FIT
          </div>
        </div>

        <div data-attribute="item" class="item-product">
          <div class="wrap-img">
            <img data-attribute="image-item-product" class="image-item-product"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ea773c1b894fec5ef8ce.png"
            alt="" />
          </div>
          <div
            data-background="#FFFFFFa1"
            data-attribute="label-product"
            data-text-color="#000000"
            class="label-product"
            style="background-color: #FFFFFFa1; --background-label-product: #FFFFFFa1; color: #000000;"
          >
            MOVE WITH YOUR BODY
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
